exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n/* layout contants from `layout-constants.js` */\n.inline-message_inline-message_2feS3 {\n    color: hsla(55, 90%, 95%, 1);\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    font-size: .8125rem;\n}\n.inline-message_success_1jfE0 {\n    color: hsla(55, 90%, 95%, 0.75);\n}\n.inline-message_info_E7dNO {\n    color: hsla(55, 90%, 95%, 1);\n}\n.inline-message_warn_3DS5G {\n    color: hsla(55, 90%, 75%, 1);\n}\n.inline-message_spinner_1vybW {\n    margin-right: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"inline-message": "inline-message_inline-message_2feS3",
	"inlineMessage": "inline-message_inline-message_2feS3",
	"success": "inline-message_success_1jfE0",
	"info": "inline-message_info_E7dNO",
	"warn": "inline-message_warn_3DS5G",
	"spinner": "inline-message_spinner_1vybW"
};